import { Button, Menu, MenuItem } from '@mui/material'
import useStyles from './styles'
import { useRef, useState } from 'react'
import { LineHeadType } from '../../drawingTools/lineDrawingTool/lineDrawingTool'

export type LineHeadSelectorProps = {
    value: LineHeadType,
    onChange: (value: LineHeadType) => void
    compact?: boolean
}

const LineHeadSelector: React.FC<LineHeadSelectorProps> = ({ value, onChange }) => {
    const { classes, cx } = useStyles()
    const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null)

    const ref = useRef<HTMLDivElement>(null)

    let displayComponent = <Button className={classes.container}
                                   onClick={() => setAnchorEl(ref.current)}>{value}</Button>

    return <div ref={ref} style={{ display: 'flex', justifyContent: 'center' }}>
        {displayComponent}
        <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            autoFocus={true}
            onClose={() => setAnchorEl(null)}
        >
            <MenuItem onClick={() => {
                onChange('normal')
                setAnchorEl(null)
            }}>Normal</MenuItem>
            <MenuItem onClick={() => {
                onChange('arrow')
                setAnchorEl(null)
            }}>Arrow</MenuItem>
        </Menu>
    </div>
}

export default LineHeadSelector

